/** Типы ответов API, общие для сервера и мини-приложения. */
import type { Role } from './roles.ts';

export interface ChildDto {
  id: string;
  familyId: string;
  name: string;
  birthDate: string;
  sex: 'male' | 'female' | null;
  birthWeightG: number | null;
  feeding: 'breast' | 'formula' | 'mixed' | null;
  /** Подписанная ссылка на фото или null. */
  photoUrl: string | null;
}

export interface FamilyDto {
  id: string;
  name: string;
  tz: string;
  role: Role;
  children: ChildDto[];
  settings: FamilySettings;
}

/** Справочники семьи (их можно править в настройках). */
export interface FamilySettings {
  sleepPlaces?: string[];
  sleepClothes?: string[];
  sleepPositions?: string[];
  sleepMethods?: string[];
  cryReasons?: string[];
  crySoothe?: string[];
  gymKinds?: string[];
  awakeActivities?: string[];
  /** Свои события семьи. */
  customKinds?: CustomKind[];
}

export interface CustomKind {
  id: string;
  name: string;
  /** Эмодзи-значок. */
  emoji: string;
  cat: 'feed' | 'sleep' | 'diaper' | 'walk' | 'awake' | 'cry' | 'other';
  /** С длительностью (таймер, начало и конец) или отметка момента. */
  timed: boolean;
  /** Варианты на выбор («критерии»): например «легко / с трудом». */
  options?: string[];
  /** Числовое значение с единицей (например «мл», «шт»), если нужно. */
  unit?: string;
}

/** Личные настройки пользователя. */
export interface UserSettings {
  /** Порядок кнопок действий на «Сегодня»; скрытые — в hidden. */
  actions?: string[];
  hiddenActions?: string[];
}

export const DEFAULT_SLEEP_PLACES = ['Кроватка', 'Коляска', 'На руках', 'С родителями', 'Автокресло', 'Слинг'];
export const DEFAULT_SLEEP_CLOTHES = ['Боди', 'Слип', 'Пелёнка', 'Спальный мешок', 'Только подгузник', 'Шапочка', 'Носочки'];
export const DEFAULT_SLEEP_POSITIONS = ['На спине', 'На левом боку', 'На правом боку', 'На животе'];
export const DEFAULT_SLEEP_METHODS = ['Укачивание', 'На руках', 'Грудь', 'Бутылочка', 'Соска', 'Белый шум', 'Колыбельная', 'Поглаживание', 'В коляске', 'Сам уснул'];

export interface MeDto {
  user: { id: number; firstName: string; username: string | null; settings: UserSettings };
  families: FamilyDto[];
}

export interface MemberDto {
  userId: number;
  name: string;
  role: Role;
  isMe: boolean;
  /** Каких детей видит: null — всех. */
  childIds: string[] | null;
}

export interface ReminderSettingsDto {
  feedIntervalMin: number | null;
  eveningSummary: boolean;
  eveningAt: string;
  quietFrom: string | null;
  quietTo: string | null;
}

export const DEFAULT_CRY_REASONS = ['Колики', 'Животик, газики', 'Запор', 'Голод', 'Устал, хочет спать', 'Зубки', 'Мокрый подгузник', 'Жарко или холодно', 'Хочет на ручки', 'Срыгивание', 'Температура', 'Без видимой причины'];
export const DEFAULT_CRY_SOOTHE = ['На ручках', 'Укачивание', 'Грудь', 'Соска', 'Тёплая пелёнка на животик', 'Массаж животика', 'Газоотводная трубочка', 'Белый шум', 'Смена подгузника', 'Прогулка', 'Само прошло'];
export const DEFAULT_GYM_KINDS = ['Гимнастика', 'Массаж', 'На животике', 'Фитбол', 'Плавание'];
export const DEFAULT_AWAKE_ACTIVITIES = ['Игра', 'Развивающие занятия', 'Изучает игрушки', 'Переодевание', 'Гигиена', 'На руках', 'На животике', 'Песенки и чтение', 'Общение с семьёй', 'В дороге', 'У врача'];
